import { useState, useEffect } from 'react';
import window from 'global/window';

/** MUI `breakpoints.up` returns `@media (…)` for styled-css; `matchMedia` needs the inner `(…)` only */
export function toMatchMediaQuery(breakpointUp) {
  return breakpointUp.replace(/^\s*@media\s+/i, '').trim();
}

const useMediaQuery = (query) => {
  const [match, setMatch] = useState(false);
  const matchMediaType = typeof window?.matchMedia;

  useEffect(() => {
    if (matchMediaType !== 'function') {
      return undefined;
    }
    const matchObject = window.matchMedia(query);
    const updateMatch = () => setMatch(matchObject.matches);

    updateMatch();
    if (matchObject.addEventListener) {
      matchObject.addEventListener('change', updateMatch);
      return () => {
        matchObject.removeEventListener('change', updateMatch);
      };
    }

    matchObject.addListener(updateMatch);
    return () => {
      matchObject.removeListener(updateMatch);
    };
  }, [query, matchMediaType]);

  return match;
};

export default useMediaQuery;
